export const en = {
    'day-budget': 'Average daily budget',
    'day-budget-custom': 'Custom period budget',
    'day-budget-off': 'disabled',
    platform: 'Show',
    settings: 'Settings',
    strategy: 'Strategy'
};
